<template>
  <div>
    <v-snackbar
      class="mt-5"
      :color='color'
      :timeout="3000"
      :top="true"
      v-model="alert"
    >{{message}}</v-snackbar>
    <v-container class="verification-link" >
      <v-layout row>
        <v-flex xs6 offset-xs3>
          <v-card class="mt-5 verification-link container border-all-1 corner-all-10 box_s">
            <h3 class="">
              Reset Password
            </h3>
            <div class="p10">
              <v-text-field
                ref="password"
                label="Enter Password*"
                v-model="password"
                type="password"
                data-vv-name="Password"
                v-validate="{required: true, regex: $store.state.passwordRegex}"
                :error-messages="errors.collect('Password')">
              </v-text-field>

              <v-text-field
                label="Confirm Password*"
                v-model="confirmPassword"
                type="password"
                data-vv-name=" password"
                data-vv-validate-on="input|update|change|blur"
                v-validate="'required|confirmed:password'"
                :error-messages="errors.collect(' password')">
              </v-text-field>
              <p class="mt-2">
                Password MUST contain an uppercase alphabet, a lowercase alphabet, a number and a symbol (!,@,#,$,%,&,*,-), and be AT LEAST 8 characters in length.
              </p>
            </div>
            <v-card-actions class="pl0">
              <v-btn color="primary rounded-0" :disabled='!confirmDialog || errors.any()' @click="setPassword()">Submit</v-btn>
              <v-btn flat @click="password = '', confirmPassword = ''">Clear</v-btn>
            </v-card-actions>
            <!-- <v-btn block @click="resendVerificationLink">Resend verification link</v-btn> -->
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VueCookie from 'vue-cookie'
export default {
  name: 'ResetPassword',
  data: () => ({
    password: '',
    confirmPassword: '',
    data: {},
    color: '',
    alert: false,
    message: ''
  }),
  created () {
    this.data = JSON.parse(VueCookie.get('userData')) || {}
    if (!(Object.keys(this.data).length > 0)) {
      this.$router.push('/')
    }
  },
  computed: {
    confirmDialog () {
      let isValid = true
      isValid = (this.password && (this.password === this.confirmPassword))
      return isValid
    }
  },
  destroyed () {
    VueCookie.delete('userData')
  },
  methods: {
    setPassword () {
      this.$validator.validateAll().then(res => {
        this.$set(this.data, 'password', this.password)
        this.$set(this.data, 'confirmPassword', this.confirmPassword)
        this.$store.dispatch('ACTION_RESET_PASSWORD', { ...this.data }).then(res => {
          if (!res.success) {
            this.color = 'error'
            this.message = res.error.message || 'Something went wrong.'
            this.alert = true
            VueCookie.delete('userData')
            setTimeout(() => {
              this.$router.push('/')
            }, 3000)
          } else {
            VueCookie.delete('userData')
            this.$store.state.forEmailVerification = false
            this.$store.state.forAdminApproval = false
            this.$router.push('/success')
          }
        })
      })
    }
  }
}
</script>

<style>

</style>
